import { validateEmail } from '@/fsd/entities/auth/lib/helpers/validateEmail';
import { PasswordResetFormErrors } from '@/fsd/entities/auth/model/types/PasswordResetFormErrors';

export const validatePasswordResetForm = ({
  email,
  newPassword,
  confirmPassword,
}: {
  email: string;
  newPassword?: string;
  confirmPassword?: string;
}) => {
  let hasErrors = false;
  const newErrors: PasswordResetFormErrors = {
    email: '',
    general: '',
    newPassword: '',
    confirmPassword: '',
  };

  const emailError = validateEmail(email);
  if (emailError) {
    newErrors.email = emailError;
    hasErrors = true;
  }

  if (newPassword && newPassword.length < 8) {
    newErrors.newPassword = 'Пароль должен быть не менее 8 символов';
    hasErrors = true;
  }

  if (newPassword && newPassword !== confirmPassword) {
    newErrors.confirmPassword = 'Пароли не совпадают';
    hasErrors = true;
  }

  return { hasErrors, ...newErrors };
};
